if (!customElements.get('pirpamer-hero')) {
  customElements.define('pirpamer-hero', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-hero-slide]')];
      if (this.slides.length < 2) return;

      this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.status = this.querySelector('[data-hero-status]');
      this.previousButton = this.querySelector('[data-hero-previous]');
      this.nextButton = this.querySelector('[data-hero-next]');
      this.toggleButton = this.querySelector('[data-hero-toggle]');
      this.toggleIcon = this.querySelector('[data-hero-toggle-icon]');
      this.manualPaused = false;
      this.pointerInside = false;
      this.focusInside = false;
      this.previousButton?.addEventListener('click', () => this.show(this.index - 1, true));
      this.nextButton?.addEventListener('click', () => this.show(this.index + 1, true));
      this.toggleButton?.addEventListener('click', () => this.toggleAutoplay());
      this.addEventListener('mouseenter', () => { this.pointerInside = true; this.stop(); });
      this.addEventListener('mouseleave', () => { this.pointerInside = false; this.start(); });
      this.addEventListener('focusin', () => { this.focusInside = true; this.stop(); });
      this.addEventListener('focusout', (event) => {
        if (event.relatedTarget && this.contains(event.relatedTarget)) return;
        this.focusInside = false;
        this.start();
      });
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.start();
    }

    disconnectedCallback() { this.stop(); }

    start() {
      this.stop();
      if (this.dataset.autoplay !== 'true' || this.reducedMotion?.matches || this.manualPaused || this.pointerInside || this.focusInside) return;
      const delay = Number(this.dataset.interval || 6) * 1000;
      this.timer = window.setInterval(() => this.show(this.index + 1, false), delay);
    }

    stop() {
      if (this.timer) window.clearInterval(this.timer);
      this.timer = undefined;
    }

    toggleAutoplay() {
      this.manualPaused = !this.manualPaused;
      this.toggleButton?.setAttribute('aria-pressed', String(this.manualPaused));
      this.toggleButton?.setAttribute('aria-label', this.manualPaused ? 'Automatischen Wechsel fortsetzen' : 'Automatischen Wechsel pausieren');
      if (this.toggleIcon) this.toggleIcon.textContent = this.manualPaused ? '\u25B6' : '\u275A\u275A';
      if (this.manualPaused) this.stop(); else this.start();
    }

    show(nextIndex, userInitiated) {
      this.index = (nextIndex + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, index) => {
        const active = index === this.index;
        slide.classList.toggle('is-active', active);
        slide.toggleAttribute('hidden', !active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      if (this.status) this.status.textContent = `${this.index + 1} / ${this.slides.length}`;
      if (userInitiated) this.start();
    }
  });
}

function initPirpamerReveals(root = document) {
  if (!document.body.classList.contains('template-index')) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const candidates = [
    ...(root.matches?.('.pirpamer-reveal') ? [root] : []),
    ...root.querySelectorAll('.pirpamer-reveal'),
  ];

  candidates.forEach((element) => {
    if (element.dataset.pirpamerRevealReady === 'true') return;
    element.dataset.pirpamerRevealReady = 'true';

    if (reducedMotion || !('IntersectionObserver' in window)) {
      element.classList.add('pirpamer-reveal--visible');
      return;
    }

    window.pirpamerRevealObserver ??= new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('pirpamer-reveal--visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });

    window.pirpamerRevealObserver.observe(element);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initPirpamerReveals(), { once: true });
} else {
  initPirpamerReveals();
}

if (!window.pirpamerHomeListenersAdded) {
  window.pirpamerHomeListenersAdded = true;

  document.addEventListener('shopify:block:select', (event) => {
    const slide = event.target.closest('[data-hero-slide]');
    const hero = slide?.closest('pirpamer-hero');
    if (!slide || !hero || !hero.slides) return;
    hero.stop();
    hero.show(hero.slides.indexOf(slide), false);
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-product-slider-previous], [data-product-slider-next]');
    if (!button) return;
    const section = button.closest('.pirpamer-home-section');
    const slider = section?.querySelector('[data-product-slider]');
    if (!slider) return;
    const direction = button.hasAttribute('data-product-slider-previous') ? -1 : 1;
    slider.scrollBy({ left: direction * slider.clientWidth, behavior: 'smooth' });
  });

  document.addEventListener('shopify:section:load', (event) => initPirpamerReveals(event.target));
}
